import { SegmentedControl } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { INSTALL_MODES, type InstallMode } from "types/headsetReleaseTypes";
import { MODE_COLORS } from "./releaseFormat";

interface InstallModeControlProps {
  value: InstallMode;
  onChange: (mode: InstallMode) => void;
  label: string;
}

export function InstallModeControl({ value, onChange, label }: InstallModeControlProps) {
  const { t } = useTranslation();
  return (
    <SegmentedControl
      aria-label={label}
      size="xs"
      value={value}
      color={MODE_COLORS[value]}
      onChange={(mode) => onChange(mode as InstallMode)}
      data={INSTALL_MODES.map((mode) => ({
        value: mode,
        label: t(`headsetReleases.mode.${mode}`),
      }))}
    />
  );
}
